export const stats = [
  {
    value: 20,
    suffix: "M",
    label: "Reach Worldwide",
    description:
      "Creating a global electronics hub that enhances how people live, work, and connect.",
  },
  {
    value: 8.5,
    suffix: "x",
    label: "Faster Growth",
    description:
      "Rapid expansion by offering cutting-edge products, great service, and global reach.",
  },
  {
    value: 100,
    suffix: "+",
    label: "Global Brands",
    description:
      "Partnering with top-tier IT & Electronics brands to lead the future of smart living.",
  },
];
